export const PERSONALISED_RECOMMENDER_TITLE_EXPERIMENT =
  "personalised_recommender_title_july_2022";
export const ONEPASS_APP_EXPERIMENT = "onepass_app_jul22";
